import { useState, useEffect } from "react";

import "./styles.css";

// Simple icon replacement (no external libraries)
const getIcon = (id) => {
  const icons = {
    1: "🏠",
    2: "📈",
    3: "🔁",
    4: "🔨",
    5: "🔀",
    6: "⚖️",
    7: "🛡️",
    8: "🤝",
    9: "📄",
    10: "💼",
  };
  return icons[id] || "⬜";
};

function Card({ card, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        border: "1px solid #E6E6E6",
        padding: 24,
        borderRadius: 12,
        cursor: "pointer",
        backgroundColor: "#ffffff",
        transition: "all 0.25s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-6px)";
        e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.08)"
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div style={{ fontSize: 24 }}>{getIcon(card.id)}</div>
      <div style={{ fontWeight: 600, marginTop: 12 }}>{card.title}</div>
      <div style={{ fontSize: 13, color: "#8e8e93", marginTop: 6, lineHeight: 1.8 }}>
        {card.description}
      </div>
    </div>
  );
}

function DetailCard({ card, onBack }) {
  const [selectedTab, setSelectedTab] = useState("overview");
  const [openFaq, setOpenFaq] = useState(null);

  const tabs = [
    {
      id: "overview",
      label: "Overview",
      content: card.detailedDescription || card.description,
    },
    ...(card.options || []).map((opt) => ({
      id: opt.id,
      label: opt.label,
      content: opt.description,
    })),
  ];

  const activeTab = tabs.find((t) => t.id === selectedTab);

  return (
    <div style={{ padding: "24px 16px" }}>
      <div
        style={{
          width: "95%",
          margin: "0 auto",
          background: "#fff",
          border: "1px solid #e5e5e5",
          boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
          borderRadius: 14,
          padding: "40px",
        }}
      >

        {/* Back */}
        <div
          onClick={onBack}
          style={{
            cursor: "pointer",
            color: "#666",
            fontSize: 14,
            marginBottom: 20,
          }}
        >
          ← Back to selection
        </div>

        {/* Title */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 25 }}>
          <div style={{ fontSize: 26 }}>{getIcon(card.id)}</div>
          <h2 style={{ fontSize: 28, margin: 0 }}>{card.title}</h2>
        </div>

        {/* Tabs */}
        <div
          style={{
            display: "flex",
            gap: 20,
            borderBottom: "1px solid #e5e5e5",
            marginBottom: 20,
            flexWrap: "wrap",
          }}
        >
          {tabs.map((tab) => (
            <div
              key={tab.id}
              onClick={() => setSelectedTab(tab.id)}
              style={{
                cursor: "pointer",
                paddingBottom: 8,
                borderBottom: selectedTab === tab.id ? "2px solid #000" : "none",
                fontWeight: selectedTab === tab.id ? 600 : 400,
              }}
            >
              {tab.label}
            </div>
          ))}
        </div>

        {/* Content */}
        <div style={{ marginBottom: 30 }}>
          <p style={{ lineHeight: 1.6 }}>
            {activeTab?.content}
          </p>
        </div>

        {/* FAQs */}
        {card.faqs && (
          <div style={{ marginBottom: 30 }}>
            <h4 style={{ marginBottom: 10 }}>FAQs:</h4>

            {card.faqs.map((faq, i) => (
              <div key={i} style={{ marginBottom: 10 }}>
                <div
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  style={{ cursor: "pointer", fontWeight: 500 }}
                >
                  {faq.question}
                </div>

                {openFaq === i && (
                  <div style={{ marginTop: 5, color: "#555" }}>
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* CTA */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          {(card.ctas || []).map((cta, index) => (
            <button
  key={index}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();

    if (cta.url) {
      window.open(cta.url, "_top");
    }
  }}
  style={{
    padding: "12px 22px",
    background: index === 0 ? "#d4a437" : "#fff",
    boxShadow: index === 0 ? "0 2px 6px rgba(0,0,0,0.08)" : "none",
    color: index === 0 ? "#fff" : "#000",
    border: index === 0 ? "none" : "1px solid #ccc",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600,
    letterSpacing: "0.2px",
    transform: "translateY(0px)",
    transition: "all 0.2s ease"
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.12)";

    if (index !== 0) {
      e.currentTarget.style.background = "#f5f5f5";
    } else {
      e.currentTarget.style.opacity = "0.95";
    }
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0px)";
    e.currentTarget.style.boxShadow =
      index === 0 ? "0 2px 6px rgba(0,0,0,0.08)" : "none";

    if (index !== 0) {
      e.currentTarget.style.background = "#fff";
    } else {
      e.currentTarget.style.opacity = "1";
    }
  }}
>
  {cta.label}
</button>
          ))}
        </div>

      </div>
    </div>
  );
}

export default function App() {
  const [selectedCard, setSelectedCard] = useState(null);

  // 🔹 Function to send height to parent (Divi iframe)
  const sendHeight = () => {
    const height = document.body.scrollHeight;

    console.log("Sending height:", height);

    window.parent.postMessage(
  { type: "setHeight", height },
  "*"
  );
  };

  // 🔹 Initial load (runs once)
  useEffect(() => {
    sendHeight();

    const timeout = setTimeout(sendHeight, 200);

    return () => clearTimeout(timeout);
  }, []);

  // 🔹 When switching between cards (grid ↔ detail)
  useEffect(() => {
    sendHeight();
  }, [selectedCard]);

  // 🔹 Detect ALL layout changes (tabs, FAQs, content expansion)
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      sendHeight();
    });

    observer.observe(document.body);

    return () => observer.disconnect();
  }, []);

  
const sampleCards = [
{
id: 1,
title: "Buy a home",
description:
"Find and secure the right home with your offer, funding, and closing aligned.",
detailedDescription:
"Buying a home is more than finding the right property - It's about aligning your financing, legal protection, and timing so everything works together. We guide you through each step, from understanding your budget to structuring a strong offer and closing with confidence. With our realty, financial, and legal teams working together, nothing is missed and every decision is made with clarity.",

ctas: [
  { label: "Speak to an advisor", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View full journey", type: "secondary", url: "https://aruldasongroup.com/index.php/buy-a-home/" },
  { label: "Explore mortgage options", type: "tertiary", url: "https://aruldasongroup.com/index.php/financial/" }
],

faqs: [
{ id: "faq1", question: "How long does the process take?", answer: "Typically 30-90 days depending on the market and financing." },
{ id: "faq2", question: "Do I need pre-approval first?", answer: "Yes. It strengthens your offer and clarifies your budget." },
{ id: "faq3", question: "What costs should I expect?", answer: "Closing costs, legal fees, taxes, and moving expenses." }
],

options: [
{
  id: "first",
  label: "First-time buyer",
  description: "Understand your budget, financing options, and every step of the process with confidence."
},
{
  id: "upgrade",
  label: "Upgrading",
  description: "Coordinate selling your current home and buying your next without timing or financing gaps."
},
{
  id: "invest",
  label: "Investment purchase",
  description: "Evaluate opportunities, returns, and risks before committing to an investment property."
},
{
  id: "vacation",
  label: "Vacation home",
  description: "Balance lifestyle goals with financing and long-term value in a second property."
},
{
  id: "relocate",
  label: "Relocating",
  description: "Plan your move, financing, and timelines clearly when transitioning to a new area."
}
]
},

{
id: 2,
title: "Sell a home",
description:
"List smart, maximize value, and close cleanly.",
detailedDescription:
"Selling your home requires more than listing — it's about positioning, pricing, and timing the market correctly. We help you prepare your property, attract the right buyers, and negotiate confidently while ensuring the legal and financial sides are fully aligned. Our integrated approach reduces risk and helps you move forward with certainty.",

ctas: [
  { label: "Speak to an agent", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View selling journey", type: "secondary", url: "https://aruldasongroup.com/index.php/sell-a-home/" },
  { label: "Explore legal process", type: "tertiary", url: "https://aruldasongroup.com/index.php/legal/" }
],

faqs: [
{ id: "faq1", question: "How is my home priced?", answer: "We use market data, comparables, and positioning strategy." },
{ id: "faq2", question: "How long will it take?", answer: "Depends on market conditions and pricing." },
{ id: "faq3", question: "What fees are involved?", answer: "Commission, legal fees, and closing costs." }
],

options: [
{
  id: "max",
  label: "Maximize value",
  description: "Prepare, position, and market your home to achieve the strongest possible sale price."
},
{
  id: "quick",
  label: "Sell quickly",
  description: "Prioritize speed while protecting value and minimizing disruption."
},
{
  id: "relocate",
  label: "Relocating",
  description: "Align your sale with your next move to avoid gaps or unnecessary pressure."
},
{
  id: "estate",
  label: "Estate / transition",
  description: "Manage the sale of a property during a life transition with clarity and support."
}
]
},

{
id: 3,
title: "Refinance",
description:
"Restructure your mortgage with clarity.",
detailedDescription:
"Refinancing can improve your financial position, but only if the structure truly fits your goals. We help you evaluate your options, understand the costs, and align your mortgage with your broader plans. By coordinating financial strategy with legal clarity, we ensure the decision works both now and long term.",

ctas: [
  { label: "Speak to an advisor", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View refinance journey", type: "secondary", url: "https://aruldasongroup.com/index.php/refinancing/" },
  { label: "Explore financial options", type: "tertiary", url: "https://aruldasongroup.com/index.php/financial/" }
],

faqs: [
{ id: "faq1", question: "When should I refinance?", answer: "When rates improve or your needs change." },
{ id: "faq2", question: "Are there penalties?", answer: "Sometimes, depending on your mortgage." },
{ id: "faq3", question: "Does it affect credit?", answer: "Minimal short-term impact." }
],

options: [
{
  id: "lower",
  label: "Lower payments",
  description: "Reduce monthly costs by securing a more favorable rate or structure."
},
{
  id: "equity",
  label: "Access equity",
  description: "Unlock funds from your home to support other financial goals."
},
{
  id: "consolidate",
  label: "Consolidate debt",
  description: "Simplify multiple debts into a single, more manageable payment."
},
{
  id: "renewal",
  label: "Renewal planning",
  description: "Review your options before renewal to ensure your mortgage still fits your needs."
},
{
  id: "change",
  label: "Change structure",
  description: "Adjust term, rate type, or flexibility to better match your situation."
}
]
},

{
id: 4,
title: "Finance a renovation",
description:
"Fund improvements that add value.",
detailedDescription:
"Renovations should enhance both your lifestyle and the value of your home. We help you determine what to invest in, how to finance it effectively, and how it impacts your overall financial position. With the right structure and planning, your project stays aligned from funding to completion.",

ctas: [
  { label: "Speak to an advisor", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View renovation journey", type: "secondary", url: "https://aruldasongroup.com/index.php/finance-a-renovation/" },
  { label: "Explore financing", type: "tertiary", url: "https://aruldasongroup.com/index.php/financial/" }
],

faqs: [
{ id: "faq1", question: "How much can I borrow?", answer: "Depends on your equity and income." },
{ id: "faq2", question: "Which projects add value?", answer: "Kitchens, bathrooms, and outdoor spaces typically lead." },
{ id: "faq3", question: "Do I need permits?", answer: "Often yes—especially for structural work." }
],

options: [
{
  id: "upgrade",
  label: "Upgrade home",
  description: "Improve comfort, functionality, and long-term value through targeted upgrades."
},
{
  id: "value",
  label: "Increase value",
  description: "Focus on renovations that provide the strongest return on investment."
},
{
  id: "repair",
  label: "Essential repairs",
  description: "Address necessary updates to maintain safety, compliance, and property value."
},
{
  id: "expand",
  label: "Expand space",
  description: "Finance additions or reconfigurations to better suit your needs."
}
]
},

{
id: 5,
title: "Bridge options",
description:
"Align buying and selling timelines.",
detailedDescription:
"Timing the sale of one home and the purchase of another can create unnecessary pressure. Bridge solutions allow you to move forward with confidence by aligning both transactions. We help structure the financing and coordinate the legal and realty timelines so everything transitions smoothly.",

ctas: [
  { label: "Speak to an advisor", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View timing strategy", type: "secondary", url: "https://aruldasongroup.com/index.php/bridge-loan/" },
  { label: "Explore financing", type: "tertiary", url: "https://aruldasongroup.com/index.php/financial/" }
],

faqs: [
{ id: "faq1", question: "What is bridge financing?", answer: "Short-term financing between transactions." },
{ id: "faq2", question: "Is it expensive?", answer: "Higher than standard loans but short-term." },
{ id: "faq3", question: "Who qualifies?", answer: "Homeowners with sufficient equity." }
],

options: [
{
  id: "buyfirst",
  label: "Buy before selling",
  description: "Secure your next home first without rushing the sale of your current property."
},
{
  id: "sellfirst",
  label: "Sell before buying",
  description: "Complete your sale first to clearly define your next purchase."
},
{
  id: "align",
  label: "Align timelines",
  description: "Coordinate both transactions to minimize stress and financial overlap."
},
{
  id: "gap",
  label: "Short-term gap",
  description: "Cover temporary timing gaps between transactions with structured financing."
}
]
},

{
id: 6,
title: "Find a real estate lawyer",
description:
"Protect every step of your transaction.",
detailedDescription:
"Every real estate transaction depends on strong legal foundations. We connect you with the right legal expertise to review agreements, manage risks, and ensure a clean closing. Working alongside your realty and financial strategy, this ensures nothing is overlooked.",

ctas: [
  { label: "Speak to legal", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View legal process", type: "secondary", url: "https://aruldasongroup.com/index.php/find-real-estate-lawyer/" },
  { label: "Explore legal services", type: "tertiary", url: "https://aruldasongroup.com/index.php/legal/" }
],

faqs: [
{ id: "faq1", question: "When do I need a lawyer?", answer: "Before closing any real estate transaction." },
{ id: "faq2", question: "What do they handle?", answer: "Contracts, title, and closing documentation." },
{ id: "faq3", question: "How much does it cost?", answer: "Varies by service and complexity." }
],

options: [
{
  id: "review",
  label: "Review agreement",
  description: "Ensure your contract is clear, accurate, and fully protects your interests."
},
{
  id: "closing",
  label: "Closing support",
  description: "Manage the legal process smoothly from agreement to final closing."
},
{
  id: "title",
  label: "Title issues",
  description: "Resolve ownership or registration concerns before they become problems."
},
{
  id: "dispute",
  label: "Dispute support",
  description: "Navigate conflicts or issues with clear legal guidance."
}
]
},

{
id: 7,
title: "Mortgage issue",
description:
"Resolve challenges quickly and clearly.",
detailedDescription:
"When mortgage challenges arise, acting early makes a difference. We help you understand your situation, explore practical options, and take the right next step. By aligning financial solutions with legal considerations, we work to stabilize your position and protect your outcome.",

ctas: [
  { label: "Get help now", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View recovery options", type: "secondary", url: "https://aruldasongroup.com/index.php/under-pressure/" },
  { label: "Explore refinancing", type: "tertiary", url: "https://aruldasongroup.com/index.php/financial/" }
],

faqs: [
{ id: "faq1", question: "What if I miss payments?", answer: "Contact your lender immediately." },
{ id: "faq2", question: "Can I renegotiate?", answer: "Often yes, depending on your situation." },
{ id: "faq3", question: "Will it affect credit?", answer: "Possibly, depending on severity." }
],

options: [
{
  id: "missed",
  label: "Missed payments",
  description: "Understand your options and take action before the situation escalates."
},
{
  id: "stress",
  label: "Financial pressure",
  description: "Restructure or adjust your mortgage to better match your situation."
},
{
  id: "renewal",
  label: "Difficult renewal",
  description: "Explore alternatives when standard renewal options are limited."
},
{
  id: "equity",
  label: "Equity concerns",
  description: "Assess your position and identify ways to stabilize your situation."
},
{
  id: "urgent",
  label: "Urgent situation",
  description: "Act quickly to protect your property and financial outcome."
}
]
},

{
id: 8,
title: "Navigating a separation",
description:
"Make informed decisions during transition.",
detailedDescription:
"Separation involves important financial and property decisions that need to be handled carefully. We provide clear, neutral guidance to help you understand your options and move forward with confidence. By aligning real estate, legal, and financial considerations, we help reduce uncertainty during a difficult time.",

ctas: [
  { label: "Speak confidentially", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View separation process", type: "secondary", url: "https://aruldasongroup.com/index.php/navigating-separation-property-decisions/" },
  { label: "Explore legal options", type: "tertiary", url: "https://aruldasongroup.com/index.php/legal/" }
],

faqs: [
{ id: "faq1", question: "What happens to the home?", answer: "Depends on your agreement." },
{ id: "faq2", question: "Can we sell?", answer: "Yes, often the simplest option." },
{ id: "faq3", question: "Who decides?", answer: "Legal guidance is key." }
],

options: [
{
  id: "sell",
  label: "Sell the home",
  description: "Divide proceeds cleanly and move forward independently."
},
{
  id: "buyout",
  label: "Buyout option",
  description: "One party retains the property while compensating the other."
},
{
  id: "coown",
  label: "Temporary co-ownership",
  description: "Maintain shared ownership for a defined period while planning next steps."
},
{
  id: "planning",
  label: "Planning next steps",
  description: "Understand your options before making any decisions."
}
]
},

{
id: 9,
title: "Create a will / POA / trust",
description:
"Put your wishes in order clearly.",
detailedDescription:
"Planning ahead ensures your wishes are respected and your family is protected. We help you understand your options, structure your documents properly, and ensure everything is aligned with your financial situation. With the right legal and financial coordination, your plan is clear and effective.",

ctas: [
  { label: "Speak to legal", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View estate planning", type: "secondary", url: "https://aruldasongroup.com/index.php/wills-and-trusts/" },
  { label: "Explore legal services", type: "tertiary", url: "https://aruldasongroup.com/index.php/legal/" }
],

faqs: [
{ id: "faq1", question: "Who needs a will?", answer: "Anyone with assets or dependents." },
{ id: "faq2", question: "How often update?", answer: "After major life events." },
{ id: "faq3", question: "Is it complex?", answer: "We simplify the process." }
],

options: [
{
  id: "create",
  label: "Create a will",
  description: "Define how your assets will be distributed clearly and effectively."
},
{
  id: "update",
  label: "Update documents",
  description: "Ensure your existing plan reflects your current situation."
},
{
  id: "trust",
  label: "Set up a trust",
  description: "Structure assets for protection, control, and efficiency."
},
{
  id: "poa",
  label: "Power of attorney",
  description: "Assign decision-making authority in case you cannot act yourself."
},
{
  id: "plan",
  label: "Full planning",
  description: "Build a complete estate plan aligned with your financial position."
}
]
},

{
id: 10,
title: "Manage an estate",
description:
"Settle matters clearly and efficiently.",
detailedDescription:
"Managing an estate involves multiple steps, from legal processes to financial decisions and property matters. We guide you through each stage clearly, helping you understand what needs to be done and when. By coordinating all aspects, we ensure the process is handled efficiently and with care.",

ctas: [
  { label: "Speak to an advisor", type: "primary", url: "https://aruldasongroup.com/index.php/contact/" },
  { label: "View estate process", type: "secondary", url: "https://aruldasongroup.com/index.php/manage-an-estate/" },
  { label: "Explore legal support", type: "tertiary", url: "https://aruldasongroup.com/index.php/legal/" }
],

faqs: [
{ id: "faq1", question: "What is probate?", answer: "Legal validation of the estate." },
{ id: "faq2", question: "How long does it take?", answer: "Varies by complexity." },
{ id: "faq3", question: "Do I need help?", answer: "Strongly recommended." }
],

options: [
{
  id: "probate",
  label: "Probate process",
  description: "Navigate the legal validation of the estate step by step."
},
{
  id: "property",
  label: "Property sale",
  description: "Manage the sale of real estate within the estate."
},
{
  id: "distribution",
  label: "Distribute assets",
  description: "Allocate assets clearly and in accordance with legal requirements."
},
{
  id: "support",
  label: "Full support",
  description: "Receive guidance across legal, financial, and property matters."
}
]
}

];

  return (
    <div style={{ padding: "32px 20px", transition: "all 0.2s ease", }}>
      {selectedCard ? (
        <DetailCard
          card={selectedCard}
          onBack={() => setSelectedCard(null)}
        />
      ) : (
        <>
          <h2 style={{ marginBottom: 20 }}>I'm here to...</h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              width: "100%",
              gap: 28,
            }}
          >
            {sampleCards.map((card) => (
              <Card
                key={card.id}
                card={card}
                onClick={() => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "tag_card_click",
    card: card.title,
  });

  setSelectedCard(card);
}}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}